/**
 * Created by kierangrosvenor on 08/05/2017.
 */

import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);

const store = new Vuex.Store(
  {
    state: {
      recipes: {
        searchModel: {
          "q": null,
          "suitabilities": [],
          "dietaryTypes": [],
          "cuisines": [],
          "categories": [],
          "carbs": [0, 500],
          "fat": [0, 500],
          "calories": [0, 3000],
          "protein": [0, 500],
          "totaltime": [0, 200]
        },
        filterData: null,
        categories: null,
        landingCache: {
          isBreakfast: false,
          isLunch: false,
          isDinner: false,
          isNight: false,
          excludeAt: null,
          lunch: {
            recipes: []
          },
          dinner: {
            recipes: []
          },
          snack: {
            recipes: []
          },
          seasonal: null,
          allergiesExcluded: null,
          dietaryTypes: null,
          cuisines: null,
          favoriteBased: {
            recipes: []
          }
        }
      },
      graphOptions: {
        showDots: false
      },
      status: {
        onboarding: {},
        payment: {
          paid: null,
        }
      },
      cards: {
        activity: {},
        mood: {},
        nutrition: {},
        ketones: {},
        weight: {},
        bloodPressure: {},
        bloodGlucose: {},
        cholesterol: {},
        insulin: {},
        sleep: {},
        medication: {}
      },
      discussion: {
        topContributors: [],
        frequentlyAsked: []
      },
      account: {},
      user: {},
      provider: {},
      i18n: {},
      list: {},
      geoLocation: {},
      activeProfile: null,
      activeProfileObject: {},
      lessons: [],
      reportingReasons: [],
      moodList: [],
      bgTagList: [],
      insulinTypes: [],
      cardOrder: [],
      hcp: {
        jobs: [],
        goals: [],
      },
      login: {},
      flashMessage: {},
      loginProviders: []
    },
    getters: {
      getRecipeSearchFilter(state) {
        return state.recipes.searchModel
      },
      getRecipeCategories(state) {
        return state.recipes.filterData
      }
    },
    mutations: {
      setRecipeSearchFilter(state, value) {
        state.recipes.searchModel = value;
      },
      setRecipesCacheTimely(state, obj) {
        state.recipes.landingCache[obj.key] = obj.val;
      },
      setRecipeCategories(state, value) {
        state.recipes.categories = value;
      },
      setRecipeFilter(state, value) {
        state.recipes.filterData = value;
      },
      setRecipesTimely(state, value) {
        state.recipes.timely = value;
      },
      setLang(state, value) {
        state.i18n.locale = value;
      },
      showGraphPoints(state, value) {
        state.graphOptions.showDots = value
      },
      setBgTagList(state, value) {
        value = value.sort(function (a, b) {
          let textA = a.tag.toUpperCase();
          let textB = b.tag.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        state.bgTagList = value;
      },
      setOnBoardingStatus(state, value) {
        state.status.onboarding = value;
      },
      setPaymentStatus(state, value) {
        state.status.payment.paid = value;
      },
      setReportingReasons(state, value) {
        state.reportingReasons = value;
      },
      setActivityCard(state, value) {
        state.cards.activity = value;
      },
      setInsulinTypes(state, value) {
        state.insulinTypes = value;
      },
      setInsulinCard(state, value) {
        state.cards.insulin = value;
      },
      setKetonesCard(state, value) {
        state.cards.ketones = value;
      },
      setMedicationCard(state, value) {
        state.cards.medication = value;
      },
      setCholesterolCard(state, value) {
        state.cards.cholesterol = value;
      },
      setBloodPressureCard(state, value) {
        state.cards.bloodPressure = value;
      },
      setBloodGlucoseCard(state, value) {
        state.cards.bloodGlucose = value;
      },
      setNutritionCard(state, value) {
        state.cards.nutrition = value;
      },
      setMoodCard(state, value) {
        state.cards.mood = value;
      },
      setWeightCard(state, value) {
        state.cards.weight = value;
      },
      setSleepCard(state, value) {
        state.cards.sleep = value;
      },
      setDiscussionContributors(state, value) {
        state.discussion.topContributors = value;
      },
      setDiscussionFrequentlyAsked(state, value) {
        state.discussion.frequentlyAsked = value;
      },
      setProvider(state, value) {
        state.provider = value;
      },
      setMoodList(state, value) {
        state.moodList = value;
      },
      setGeoLocation(state, value) {
        state.geoLocation = value;
      },
      setAccount(state, value) {
        state.account = value;
      },
      setUser(state, value) {
        state.user = value;
      },
      setLessons(state, value) {
        state.lessons = value;
      },
      setI18n(state, i18n) {
        state.i18n = i18n;
      },
      setList(state, value) {
        state.list = value;
      },
      setCardOrder(state, value) {
        state.cardOrder = value;
      },
      setActiveProfile(state, value) {
        state.activeProfile = value;
      },
      setActiveProfileObject(state, value) {
        state.activeProfileObject = value;
      },
      setHcpGoals(state, value) {
        state.hcp.goals = value;
      },
      setHcpJobs(state, value) {
        state.hcp.jobs = value;
      },
      setFlashMessage(state, value)
      {
        state.flashMessage = value
      },
      setLoginProviders(state, value)
      {
        state.loginProviders = value
      }
    }
  }
);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js